import React, { useEffect } from 'react';
import { useHistory } from "react-router-dom";

const compareLink = (existingLink, link) => {
    const pathname = existingLink.split('#')[0];
    const pathname2 = link.split('#')[0];

    return pathname === pathname2;
}

const useBreadCrumbs = ({
    path = {}
}) => {
    const history = useHistory();
    const pathId = path && ('id' in path) ? path.id : null;

    const getBreadCrumbs = () => {
        return JSON.parse(sessionStorage.getItem("breadcrumbs-trakref")) || [];
    }

    const saveBreadCrumbs = (newPath) => {
        const crumbs = getBreadCrumbs();
        const exitingCrumbs = crumbs.findIndex(x => x.id === newPath.id);

        if (exitingCrumbs >= 0) {
            return removeBreadCrumbs(crumbs[exitingCrumbs].link);
        }

        if (exitingCrumbs > -1) {
            crumbs[exitingCrumbs] = newPath;
        }
        else {
            if (crumbs.length !== 0 && crumbs[crumbs.length - 1].shouldBeReplaced) {
                crumbs[crumbs.length - 1] = newPath;
            } else {
                crumbs.push(newPath);
            }
        }
        
        sessionStorage.setItem("breadcrumbs-trakref", JSON.stringify(crumbs));
    }

    const updateBreadCrumbs = (newPath) => {
        const crumbs = getBreadCrumbs();
        const exitingCrumbs = crumbs.findIndex(x => x.id === newPath.id);

        if (exitingCrumbs <= -1) 
            return;

        crumbs[exitingCrumbs] = newPath;
        sessionStorage.setItem("breadcrumbs-trakref", JSON.stringify(crumbs));
    }

    const getSortedBreadCrumbs = () => {
        const currentPathname = history && history.location ? history.location.pathname : '';
        const crumbs = getBreadCrumbs().map(x => ({
            text: x.text,
            ...(currentPathname !== x.link && { to: x.link })
        }));

        return crumbs;
    }

    const removeBreadCrumbs = (link) => {
        if (!link || !path)
            return;

        if (link === '/') {
            return clearBreadCrumbs();
        }

        const crumbs = getBreadCrumbs();
        const exitingCrumbs = crumbs.findIndex(x => compareLink(x.link, link));

        crumbs.splice(exitingCrumbs + 1);
        sessionStorage.setItem("breadcrumbs-trakref", JSON.stringify(crumbs));
    }

    const clearBreadCrumbs = (checkExistingPath = false) => {
        if (checkExistingPath) {
            const crumbs = getBreadCrumbs();
            const currentPathname = history && history.location ? history.location.pathname : '';
            const exitingCrumbs = crumbs.findIndex(x => compareLink(x.link, currentPathname));
            if (exitingCrumbs >= 0) {
                return
            }
        }

        sessionStorage.removeItem("breadcrumbs-trakref");
    }

    useEffect(() => {
        if (!path) {
            return;
        }

        if ('reset' in path && !!path.reset) {
            clearBreadCrumbs();
        }

        saveBreadCrumbs(path);
    }, [pathId])

    return {
        updateBreadCrumbs,
        removeBreadCrumbs,
        clearBreadCrumbs,
        getSortedBreadCrumbs
    }
}

export default useBreadCrumbs;